import React from 'react';
import LeadVendite from './LeadVendite';
import LeadContatti from './LeadContatti';
import Visite from './Visite';

function Contatti() {
  return (
    <div>
      <h1>Dashboard Vendite e Contatti</h1>
      <LeadVendite />
      <LeadContatti />
      <Visite />
    </div>
  );
}

export default Contatti;

